import React from 'react';
import { Card, Spinner, Button, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { downloadEventPlanById } from '../../../service/workflow-api';

const ReviewSummary = ({ formData, loading, summary, planId }) => {
  const camelCaseToWords = (camelCase) => {
    const result = camelCase.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
  };

  const handleDownload = async () => {
    try {
      const response = await downloadEventPlanById(planId);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'event_plan.xlsx');
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading event plan:", error);
    }
  };

  return (
    <Card className="dark-main-card text-light">
      <Card.Body className="p-4">
        <div className="d-flex justify-content-between align-items-start mb-4">
          <h3 className="text-white" style={{ fontSize: "1.5rem" }}>Summary</h3>
          <Button
            title="Download Comprehensive Plan"
            variant="primary"
            className="dark-primary-button"
            onClick={handleDownload}
          >
            Export Excel
            <FontAwesomeIcon icon={faDownload} className="ms-1" />
          </Button>
        </div>
        <Alert variant='default'><FontAwesomeIcon icon={faInfoCircle} /> We've generated AI powered excel with more details. Please download to check.</Alert>
        {loading ? (
          <div className="text-center">
            <p className="text-muted">Performing AI Based Analysis and Generating Result...</p>
            <Spinner animation="border" variant="primary" />
          </div>
        ) : summary && summary.length > 0 ? (
          <table className="table table-borderless table-dark">
            <tbody>
              {summary.map((item) => (
                <tr key={item.key}>
                  <th scope="row">{camelCaseToWords(item.key)}</th>
                  <td>{item.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-muted">No data to display.</p>
        )}
      </Card.Body>
    </Card>
  );
};

export default ReviewSummary;